



































import { Component, Vue } from 'vue-property-decorator';
import Users from '@/components/Users.vue';
import Targets from '@/components/Targets.vue';
import SignUp from '@/views/SignUp.vue';

@Component({
  components: {
    SignUp,
    Targets,
    Users
  },
})

export default class Admin extends Vue {
  private model: string = 'users';

}
